export const getLoggedInOwnerId = () => {
  try {
    if (typeof window === "undefined") return "";
    return (
      localStorage.getItem("userId") ||
      localStorage.getItem("owner_id") ||
      localStorage.getItem("ownerId") ||
      ""
    );
  } catch (error) {
    console.warn("Unable to read owner id from storage", error);
    return "";
  }
};

